import { heroCards } from "@/mocks/homeContent";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20tropical%20gradient%20background%20with%20golden%20amber%20and%20deep%20forest%20green%20organic%20shapes%2C%20stylized%20durian%20fruit%20silhouette%20motif%2C%20cinematic%20soft%20lighting%2C%20rich%20dark%20tones%20for%20text%20contrast%2C%20modern%20editorial%20poster%20style&width=1920&height=1080&seq=durian-hero-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/75 to-foreground-950/90"></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-6 pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-primary-200 bg-background-50/10 border border-background-50/20 px-3 py-1 rounded-full">
            <i className="ri-information-line" aria-hidden="true"></i>
            安卓版 · 苹果版 · 最新版安装指引
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-background-50">
            榴莲视频app下载安装全指南
          </h1>
          <p className="mt-5 text-sm md:text-lg leading-relaxed text-background-100 max-w-2xl">
            这里汇总榴莲视频安卓版与苹果版安装包的获取方式，覆盖最新版更新说明与常见安装问题，
            并一步步带你在手机上完成下载、授权与登录，快速进入视频社区。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#install"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium px-6 py-3 rounded-md transition-colors whitespace-nowrap"
            >
              <i className="ri-download-2-line" aria-hidden="true"></i>
              查看下载安装步骤
            </a>
            <a
              href="#faq"
              className="inline-flex items-center justify-center gap-2 bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 text-sm md:text-base font-medium px-6 py-3 rounded-md transition-colors whitespace-nowrap"
            >
              <i className="ri-question-line" aria-hidden="true"></i>
              遇到安装问题
            </a>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {heroCards.map((card) => (
            <a
              key={card.id}
              href={card.href}
              className="group block bg-background-50/10 hover:bg-background-50/20 border border-background-50/20 rounded-lg p-5 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-10 h-10 rounded-md bg-accent-500/90 text-background-50 flex items-center justify-center text-xl">
                  <i className={card.icon} aria-hidden="true"></i>
                </span>
                <span className="text-[11px] font-medium text-background-100 bg-background-50/10 px-2 py-0.5 rounded-full">
                  {card.tag}
                </span>
              </div>
              <h2 className="mt-4 text-base font-semibold text-background-50">
                {card.title}
              </h2>
              <p className="mt-2 text-xs md:text-sm leading-relaxed text-background-200">
                {card.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs text-primary-200 group-hover:gap-2 transition-all">
                前往查看
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}